import { createContext } from 'react';

const ContainerContext = createContext();

export default ContainerContext;
